"use client"

import * as React from "react"

import { Button } from "./components/ui/button"
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "./components/ui/card"
import { Input } from "./components/ui/input"
import { Label } from "./components/ui/label"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./components/ui/select"
import { Textarea } from "./components/ui/textarea"

export function CardsReportIssue() {
  const id = React.useId()

  return (
    <Card>
      <CardHeader>
        <CardTitle>문제 신고</CardTitle>
        <CardDescription>어떤 영역에서 문제가 발생했나요?</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-6">
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="flex flex-col gap-3">
            <Label htmlFor={`area-${id}`}>영역</Label>
            <Select defaultValue="billing">
              <SelectTrigger id={`area-${id}`} aria-label="영역" className="w-full">
                <SelectValue placeholder="선택" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="team">팀</SelectItem>
                <SelectItem value="billing">결제</SelectItem>
                <SelectItem value="account">계정</SelectItem>
                <SelectItem value="deployments">배포</SelectItem>
                <SelectItem value="support">지원</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="flex flex-col gap-3">
            <Label htmlFor={`security-level-${id}`}>심각도</Label>
            <Select defaultValue="2">
              <SelectTrigger
                id={`security-level-${id}`}
                className="w-full [&_span]:!block [&_span]:truncate"
                aria-label="심각도"
              >
                <SelectValue placeholder="레벨 선택" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="1">심각도 1 (최고)</SelectItem>
                <SelectItem value="2">심각도 2</SelectItem>
                <SelectItem value="3">심각도 3</SelectItem>
                <SelectItem value="4">심각도 4 (최저)</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <Label htmlFor={`subject-${id}`}>제목</Label>
          <Input id={`subject-${id}`} placeholder="도움이 필요한 내용..." />
        </div>
        <div className="flex flex-col gap-3">
          <Label htmlFor={`description-${id}`}>설명</Label>
          <Textarea
            id={`description-${id}`}
            placeholder="문제와 관련된 모든 정보를 포함해 주세요."
            className="min-h-28"
          />
        </div>
      </CardContent>
      <CardFooter className="justify-end gap-2">
        <Button variant="ghost" size="sm">
          취소
        </Button>
        <Button size="sm">제출</Button>
      </CardFooter>
    </Card>
  )
}
